import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { useMutation, useQuery } from "@apollo/react-hooks";
import { MY_NEWS_GET_ITEM, MY_NEWS_REMOVE_ITEM } from "my-news/graphql";
import { useOcSnackbar } from "oc/hooks";

export const useMyNewsItem = ({ _id }: { _id: string }) => {
  const { t } = useTranslation();
  const { setOpenMessage } = useOcSnackbar();

  const { data, loading, error } = useQuery(MY_NEWS_GET_ITEM, {
    fetchPolicy: "cache-and-network",
    skip: !_id,
    variables: { _id },
  });

  const [removeMyNewsItemMutation] = useMutation(MY_NEWS_REMOVE_ITEM);

  const removeMyNewsItem = useCallback(
    async (options?: any) => {
      try {
        const result = await removeMyNewsItemMutation(options);
        setOpenMessage({
          type: "success",
          message: t("OC_OPERATION_SUCCESSFUL"),
        });
        return result;
      } catch (error) {
        console.log({ error });
        setOpenMessage({
          type: "error",
          message: t("OC_OPERATION_UNSUCCESSFUL"),
        });
        throw error;
      }
    },
    [removeMyNewsItemMutation, setOpenMessage, t],
  );

  return {
    data: data?.getMyNewsItem || null,
    loading,
    error,
    removeMyNewsItem,
  };
};

export default useMyNewsItem;
